import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const seo: Omit<LocalePerProduct, 'oranum'> = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.myContent.payingSnapshots.seo.livejasmin.title',
      defaultMessage: 'Paying Snapshots',
    },
    description: {
      id: 'pages.myContent.payingSnapshots.seo.livejasmin.description',
      defaultMessage: 'Paying Snapshots',
    },
  }),
};

const info = {
  ...defineMessages({
    title: {
      id: 'pages.myContent.payingSnapshots.info.title',
      defaultMessage: 'Earn with every Snapshot!',
    },
    description1: {
      id: 'pages.myContent.payingSnapshots.info.description1',
      defaultMessage:
        'You can <b>earn up to {price}</b> for each Snapshot, so encourage your guests to take as many pictures possible.',
    },
    description2: {
      id: 'pages.myContent.payingSnapshots.info.description2',
      defaultMessage: 'When a snapshot is taken, you will see a flash on your screen while streaming.',
    },
  }),
};

const toggle = {
  ...defineMessages({
    label: {
      id: 'pages.myContent.payingSnapshots.toggle.label',
      defaultMessage: 'Paying Snapshots',
    },
    tooltip: {
      id: 'pages.myContent.payingSnapshots.toggle.tooltip',
      defaultMessage: 'You can’t change this setting while online.{br}Please go offline to modify it.',
    },
  }),
};

const stat = {
  ...defineMessages({
    label1: {
      id: 'pages.myContent.payingSnapshots.stat.label1',
      defaultMessage: 'Actual period income',
    },
    label2: {
      id: 'pages.myContent.payingSnapshots.stat.label2',
      defaultMessage: 'Overall income',
    },
  }),
};

export default {
  pages: {
    myContent: {
      payingSnapshots: {
        seo,
        info,
        toggle,
        stat,
        navigationMenu: {
          ...defineMessages({
            label: {
              id: 'pages.myContent.payingSnapshots.navigationMenu.label',
              defaultMessage: 'Paying Snapshots',
            },
          }),
        },
      },
    },
  },
};
